var map = {
	"./google-play-badge-da-DK.svg": 84804,
	"./google-play-badge-de-DE.svg": 33062,
	"./google-play-badge-en-GB.svg": 67932,
	"./google-play-badge-en-US.svg": 63367,
	"./google-play-badge-es-ES.svg": 42480,
	"./google-play-badge-es-MX.svg": 51107,
	"./google-play-badge-fr-FR.svg": 67611,
	"./google-play-badge-it-IT.svg": 14334,
	"./google-play-badge-nb-NO.svg": 17413,
	"./google-play-badge-nl-NL.svg": 56196,
	"./google-play-badge-pl-PL.svg": 92668,
	"./google-play-badge-pt-BR.svg": 56912,
	"./google-play-badge-pt-PT.svg": 94044,
	"./google-play-badge-sv-SE.svg": 72685
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 31724;